import { __mathop } from "./internal/mathop.js";
export function add(...args) {
    return __mathop(add, (acc, x) => acc + x, 0, args);
}
